import { TableTransaction } from '@/pages/Admin/Home';
import apiClient from './_axios';

const API_URL = import.meta.env.VITE_API_URL; // or from '@/constants'

export interface TransactionResponse {
   transactions: TableTransaction[];
}

export interface TotalSalesResponse {
   totalSales: number;
}
export interface TotalPayoutReceived {
   totalPayoutReceived: number;
}
export interface TotalPayoutAvailable {
   totalPayoutAvailable: number;
}

export interface TodaySalesYesterdaySalesResponse {
   today: number;
   yesterday: number;
   percentage: number;
}

export interface TotalSalesThisWeekAndLastWeekResponse {
   thisWeek: number;
   lastWeek: number;
   percentage: number;
}
export interface TotalSalesThisMonthAndLastMonthResponse {
   thisMonth: number;
   lastMonth: number;
   percentage: number;
}
// const token =
//    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2N2Q5M2RkMmJiYzQ4Yjk1Nzg3ZTZjYzAiLCJpYXQiOjE3NDIyOTM5MzB9.PYeL53rBVU6O8ev1__HyO4Es8sdvD_58Rn38xZ8DRnY';

export async function fetchTransactions(): Promise<TransactionResponse> {
   const response = await apiClient.get<TransactionResponse>('/transaction');
   return response.data;
}

// enter here all controllers for transaction from server/src/controllers/transaction.ts
// getAllTransactions
// getTotalSales
// getTotalSalesTodayAndYesterday
// getTotalSalesThisWeekAndLastWeek
// getTotalSalesThisMonthAndLastMonth

export async function getTotalSales(): Promise<TotalSalesResponse> {
   const response = await apiClient.get<TotalSalesResponse>(
      '/transaction/total-sales'
   );
   return response.data;
}

export async function getTotalSalesTodayAndYesterday(): Promise<TodaySalesYesterdaySalesResponse> {
   const response = await apiClient.get<TodaySalesYesterdaySalesResponse>(
      '/transaction/total-sales-today-and-yesterday'
   );
   return response.data;
}

export async function getTotalSalesThisWeekAndLastWeek(): Promise<TotalSalesThisWeekAndLastWeekResponse> {
   const response = await apiClient.get<TotalSalesThisWeekAndLastWeekResponse>(
      '/transaction/total-sales-this-week-and-last-week'
   );
   return response.data;
}

export async function getTotalSalesThisMonthAndLastMonth(): Promise<TotalSalesThisMonthAndLastMonthResponse> {
   const response =
      await apiClient.get<TotalSalesThisMonthAndLastMonthResponse>(
         '/transaction/total-sales-this-month-and-last-month'
      );
   return response.data;
}
